module.exports = '<svg width="36" height="32" viewBox="0 0 36 32"><path d="M18.739.32c-.402-.396-1.051-.442-1.453-.046L.23 17.18c-.4.396-.266.809.3.809h3.472v13.009c0 .552.448 1.001 1.001 1.001h7.869c.566.002 1.137-.452 1.137-1.013v-7.991c0-.552.448-1.001 1.001-1.001h6.004c.552 0 1.001.448 1.001 1.001v7.992c0 .56.57 1.015 1.137 1.015h7.869c.552 0 1.001-.448 1.001-1.001V17.992h3.47c.566 0 .702-.412.3-.809L18.738.321z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/house-2.js
// module id = 1175
// module chunks = 14